import React from 'react';
import {Provider} from 'react-redux'
import {render} from 'react-dom';
import * as _ from 'lodash';
import {createReduxStore} from './storages/ReduxStore';
import compareModelStore from './storages/CompareModelStore';
import {CompareBucket} from './containers/CompareBucket'

export const CompareBucketRedux = () => {
    const containers = document.getElementsByClassName('compare-bucket');
    if (containers.length) {
        const productId = containers[0].getAttribute('data-product-id');
        const superCategoryId = containers[0].getAttribute('data-super-category-id');

        compareModelStore.getModels({currentModelId: productId, superCategoryId: superCategoryId, callback: (currentModel = {}, bucket = []) => {
            const store = createReduxStore({
                compareBucket: {
                    currentModel: currentModel,
                    bucket: bucket
                }
            });
            _.forEach(containers, (container) => {
                render(
                    <Provider store={store}>
                        <CompareBucket/>
                    </Provider>,
                    container
                );
            });
        }});
    }
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/index.js